"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgSmallMinus(props) {
    return React.createElement(
        "svg",
        Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            width: 12,
            height: 12,
            viewBox: "0 0 12 12",
            fill: "currentColor"
        }, props),
        React.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h12v12H0z" }),
            React.createElement("rect", {
                width: 8,
                height: 2,
                x: 2,
                y: 5,
                fill: "currentColor",
                rx: 1
            })
        )
    );
}
exports.default = SvgSmallMinus;